export default "__VITE_ASSET__BuZ3ymmP__"